import ScalarColorModeToggle_vue_vue_type_script_setup_true_lang_default from "./ScalarColorModeToggle.vue.script.js";
//#region src/components/ScalarColorModeToggle/ScalarColorModeToggle.vue
var ScalarColorModeToggle_default = ScalarColorModeToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarColorModeToggle_default as default };

//# sourceMappingURL=ScalarColorModeToggle.vue.js.map